import styled, { css } from 'styled-components';

// Credit: https://github.com/ibrahimcesar/react-lite-youtube-embed

export const LiteYouTubeEmbedStyles = styled.div`
  position: relative;
  display: block;
  width: 100% !important;
  height: 100% !important;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  /* play button styles */
  > .lty-playbtn {
    width: 88px;
    height: 62px;
    z-index: 1;
    opacity: 0.8;
    transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
  }
  > .lty-playbtn {
    opacity: 1;
  }

  > .lty-playbtn,
  > .lty-playbtn:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }

  /* Post-click styles */
  &.lyt-activated {
    cursor: unset;
  }
  &.lyt-activated::before,
  &.lyt-activated > .lty-playbtn {
    opacity: 0;
    pointer-events: none;
  }
`;

export const IframeContainer = styled.div<{ width: number; ready: boolean }>`
  position: relative;
  display: block;
  width: 100%;
  background-color: #000;
  max-width: ${({ width }) => (width ? `${width}px` : '100%')} !important;
  margin: auto;
  contain: content;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s;

  ${({ ready }) =>
    ready &&
    css`
      visibility: visible;
      opacity: 1;
    `};
  }

  &:before {
    content: '';
    display: block;
    padding-bottom: ${({ width }) => Math.ceil(width * 0.5625)}px;
  }
`;

export const IframeWrapper = styled.div<{ ready: boolean }>`
  visibility: hidden;
  opacity: 0;
  ${({ ready }) =>
    ready &&
    css`
      visibility: visible;
      opacity: 1;
    `}
  transition: all 0.2s 0.1s;
`;
